import { DASHBOARD_PERIODS } from 'shared/api';
import { TIME_ZONES } from 'shared/config';

export const DASHBOARD_METRIC_KEYS = [
	'bets',
	'wins',
	'ggr',
	'deposits',
	'withdrawals',
	'income',
	'jackpots',
	'bonuses',
	'vouchers',
] as const;

export const PERIOD_OPTIONS = [
	{ value: DASHBOARD_PERIODS.lastDay, labelKey: 'dashboard-page.periods.last-day' },
	{ value: DASHBOARD_PERIODS.last7Days, labelKey: 'dashboard-page.periods.last-7-days' },
	{ value: DASHBOARD_PERIODS.last30Days, labelKey: 'dashboard-page.periods.last-30-days' },
	{ value: DASHBOARD_PERIODS.last6Months, labelKey: 'dashboard-page.periods.last-6-months' },
] as const;

export const TIME_ZONE_OPTIONS = Object.entries(TIME_ZONES).map(([label, value]) => ({
	value: String(value),
	label,
}));

export const CHART_COLORS = [
	'#8884D8',
	'#82CA9D',
	'grape.6',
	'orange.6',
	'pink.6',
	'green.8',
	'violet.9',
	'cyan.6',
	'red.6',
	'orange.9',
	'lime.6',
	'yellow.6',
	'blue.9',
	'teal.9',
] as const;

export const CHART_DOT_WIDTH = 12;

export const CHART_DOT_HEIGHT = 8;

export const CHART_DOT_BORDER = 2;
